import { Box, Typography } from '@mui/material';
import { FONT_SIZE_EXTRA_SMALL_NUMBER } from 'providers/designSystem';
import { useEffect, useState } from 'react';
import { ColourSwatch } from './ColourSwatch';
import { useColourSettingContext } from 'context/ColourSettingProvider';

export const CopyableColourSwatch = ({ id, colour, size }) => {
    const [isCopied, setIsCopied] = useState(false);
    const [colourSetting] = useColourSettingContext();

    const copyValueToClipboard = colour => {
        const hslValue = `hsl(${colour.hue}, ${colour.saturation}%, ${colour.lightness}%)`;
        const hexValue = `#${colour.hex}`;

        const colourValue = colourSetting === 'hsl' ? hslValue : hexValue;
        navigator.clipboard.writeText(colourValue);
    };

    const handleClick = () => {
        copyValueToClipboard(colour);
        setIsCopied(true);
    };

    useEffect(() => {
        let scheduledFunctionId;

        if (isCopied) {
            scheduledFunctionId = setTimeout(() => {
                setIsCopied(false);
            }, 1000);
        }

        return () => {
            if (scheduledFunctionId) {
                clearTimeout(scheduledFunctionId);
            }
        };
    }, [isCopied]);

    return (
        <Box
            sx={{
                position: 'relative',
            }}
        >
            {isCopied && (
                <Box className={'copyBox'}>
                    <Typography
                        sx={{
                            fontSize: FONT_SIZE_EXTRA_SMALL_NUMBER,
                        }}
                    >
                        Copied!
                    </Typography>
                </Box>
            )}
            <ColourSwatch testId={`colour-swatch-${id}`} id={id} colour={colour} onClick={handleClick} size={size} />
        </Box>
    );
};
